module.exports = __webpack_public_path__ + "static/hero-logo-f206e046d77e9d4b2d4602a47ea058c8.png";